import { UseCustomAxios } from "../../UseCustomAxios";
import { useSnackbar } from "notistack";
import { isEmpty } from "../../util/Utils";

export function UseDiscountCodeReports() {
  const MyAxios = UseCustomAxios();

  const GetDiscountCodeReports = (newMyPc, search, bool, callback) => {
    MyAxios.get(`Admin_DiscountCodeReport?w=${search}`, {
      headers: {
        Conditions: JSON.stringify({ pageCondition: newMyPc }),
        IsPage: bool,
      },
    }).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  const GetDiscountCodeReportsById = (CodeId, callback) => {
    MyAxios.get(`Admin_DiscountCodeReport/${CodeId}`).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  return {
    GetDiscountCodeReports,
    GetDiscountCodeReportsById,
  };
}
